/**
 * Padding Module
 * Removes bottom padding from sections that have the same background color as the next section
 */

export default class PaddingHandler {
    init() {
        // Get all sections on the page
        const sections = document.querySelectorAll('section');

        sections.forEach((section, index) => {
            // Skip if this is the last section
            if (index === sections.length - 1) return;

            // Get the next section
            const nextSection = sections[index + 1];

            // Get all classes from current section
            const currentClasses = Array.from(section.classList);
            // Get all classes from next section
            const nextClasses = Array.from(nextSection.classList);

            // Find bg- classes in current section
            const currentBgClass = currentClasses.find(cls => cls.startsWith('bg-'));
            // Find bg- classes in next section
            const nextBgClass = nextClasses.find(cls => cls.startsWith('bg-'));

            // If both sections have the same bg- class, remove bottom padding
            if (currentBgClass && nextBgClass && currentBgClass === nextBgClass) {
                section.classList.add('!-mb-margins');
            }
        });
    }
}
